<script setup>
import { ref, onMounted } from 'vue';
import requestApi from '@/utils/requestApi';
import { useFelixBagAuxStore, useGlobalStateStore, useVideobotContentStore } from '../../store';

const felixBagAuxStore = useFelixBagAuxStore();
const globalStateStore = useGlobalStateStore();
const videobotContentStore = useVideobotContentStore();

let name = ref('')
let login = ref(false)
let loginMode = ref(false)
let credential = ref('')
let errorLogin = ref(false)
let requestingLogin = ref(false)
let saibaMais = ref(false)
let loading = ref(true)
let contentSelected = ref(false)

let isAuth = ref(false)
let checkUnico = ref(window.ovmConfig.env["TRILHA"] === "LINK_UNICO")

const authEmail = ref(true);
const authCodigo = ref(false);

const erroEmail = ref(false)
const erroCodigo = ref(false)

const loadEmail = ref(false)
const loadCodigo = ref(false)

const codigoInput = ref('');
const emailInput = ref('');

const audio = document.createElement("audio");

onMounted(async () => {
  checkName()
  checkTrilha()
  // playAudio()
  verificaExpectativaDocumentos()
  if (window.ovmConfig.env['CPF'] === 'LINK_UNICO' || window.ovmConfig.env['TRILHA'] === 'LINK_UNICO') {
    await videobotContentStore.load();
    loading.value = false
  }
});

// function playAudio() {
//   audio.pause();
//   audio.src = "./midia_branca.mp3";
//   audio.play();
// }

async function verificaExpectativaDocumentos() {
  let trilhas = ['gestante', 'parceria']
  if (window.ovmConfig.env['CPF'] && trilhas.includes(window.ovmConfig.env['TRILHA'])) {
    let cpfChave = window.ovmConfig.env['CPF'].toString();
    await requestApi({
      url: `/v2/documents/${cpfChave}`,
      method: "GET",
      headers: {
        BCS: globalStateStore.uuid,
        'Content-Type': 'application/json',
      },
      dataType: 'json'
    }).then(response => {
      if (response.data.result.length == 0) {
        criaExpectativaDocumentos();
      } else {
        for (let x = 0; x < response.data.result.length; x++) {
          if (response.data.result[x].type === 'Exame Beta') {
            globalStateStore.exames['EXAME_BETA'] = {
              status: response.data.result[x]._status,
            }
          } else if (response.data.result[x].type === 'Exame Ultrassom') {
            globalStateStore.exames['EXAME_ULTRASSOM'] = {
              status: response.data.result[x]._status,
            }
          }
        }
      }
    }).catch(function (error) {
      console.log(error)
    })
  }
}

async function criaExpectativaDocumentos() {
  var body;
  if (window.ovmConfig.env['TRILHA'] === 'gestante') {
    body = {
      persons_key: window.ovmConfig.env["CPF"].toString(),
      docs: [
        { type: "Exame Ultrassom", api: "s3", classification: "Documento Pessoal" }
      ],
    };
  } else if (window.ovmConfig.env['TRILHA'] === 'parceria') {
    body = {
      persons_key: window.ovmConfig.env["CPF"].toString(),
      docs: [
        { type: "Exame Beta", api: "s3", classification: "Documento Pessoal" },
        { type: "Exame Ultrassom", api: "s3", classification: "Documento Pessoal" }
      ],
    };
  }
  
  await requestApi({
    url: `/v2/documents`,
    method: "POST",
    headers: {
      BCS: globalStateStore.uuid,
      'Content-Type': 'application/json',
    },
    dataType: 'json',
    data: JSON.stringify(body)
  }).then(response => {
    console.log("Sucesso!");
    console.log(response.data)
    if (window.ovmConfig.env['ANEXO_BETA_HCG']) {
      uploadDocumentToApi('Exame Beta', 'ANEXO_BETA_HCG')
    }
    if (window.ovmConfig.env['ANEXO_EXAME_ULTRASSOM']) {
      uploadDocumentToApi('Exame Ultrassom', 'ANEXO_EXAME_ULTRASSOM')
    }
  }).catch(function (error) {
    console.log("Erro na criação de expectativa de documentos!");
    console.log(error)
  })
}

async function uploadDocumentToApi(docType, docToUpload) {
  let cpfChave = window.ovmConfig.env['CPF'].toString();
  let doc = window.ovmConfig.env[docToUpload].toString()
  let docExtension = ''
  if (doc) {
    if (doc.slice(-3).toLowerCase() === 'png') {
      docExtension = '.png';
    } else if (doc.slice(-3).toLowerCase() === 'svg') {
      docExtension = '.svg';
    } else if (doc.slice(-4).toLowerCase() === 'jpeg') {
      docExtension = '.jpeg';
    } else if (doc.slice(-3).toLowerCase() === 'pdf') {
      docExtension = '.pdf';
    } else if (doc.slice(-3).toLowerCase() === 'jpg') {
      docExtension = '.jpg';
    }
  }
  
  let nomeDoc = docToUpload + docExtension
  var body = {
    type: docType,
    replace: 'true',
    files: [
      {
        name: nomeDoc,
        content: await imageUrlToBase64(window.ovmConfig.env[docToUpload]),
      },
    ],
  };

  await requestApi({
    url: `/v2/documents/${cpfChave}/upload`,
    method: "PATCH",
    headers: {
      BCS: globalStateStore.uuid,
      'Content-Type': 'application/json',
    },
    dataType: 'json',
    data: JSON.stringify(body)
  }).then(response => {
    console.log("Sucesso!");
    console.log(response.data)
  }).catch(function (error) {
    console.log("Erro na criação de expectativa de documentos!");
    console.log(error)
  })
}

async function imageUrlToBase64(url) {
  return fetch(url)
  .then(response => response.blob())
  .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
  }));
}

function checkName() {
  if (window.ovmConfig.env['NOME_SOCIAL']) {
    name.value = window.ovmConfig.env['NOME_SOCIAL'].split(" ")[0]
  } else if (window.ovmConfig.env['NOME_CADASTRADO']){
    name.value = window.ovmConfig.env['NOME_CADASTRADO'].split(" ")[0]
  } else{
    name.value = window.ovmConfig.env['PRIMEIRO_NOME']
  }
}
function checkTrilha(){
  if (window.ovmConfig.env['CPF'] === '' || window.ovmConfig.env['CPF'] === 'LINK_UNICO'){
    login.value = true
  }
}

function submitAcess() {
  audio.pause();
  requestingLogin.value = true
  window.felixBag?.trigger(window.Ovm.JB.Evt.THUMBNAIL_CLICKED);
}

function formatCredential() {
  if (credential.value) {
    let credentialFormat = credential.value
    return credentialFormat.replace(/[^0-9]/g, '')
  }
}

function required(v) {
  if (v) return true

  return "Campo obrigatório"
}

function numbersOnly(evt) {
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode < 48 || charCode > 57) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function clearCpf() {
  errorLogin.value = false
}

async function loginToVideo(){
  requestingLogin.value = true
  if (credential.value) {
    requestApi({
      url: `/v3/healthbit/get_short_url`,
      method: "post",
      headers: {
        'Videobot-Token': localStorage.getItem('TOKEN_VIDEOBOT')
      },
      data: {
        "viewer_id": formatCredential()
      }
    }).then(response => {
      window.open(response.data.short_url, '_self');
    }).catch(function (error) {
      if (error.response.data.message === 'Collaborator not found') {
        errorLogin.value = true
      }
      requestingLogin.value = false
    })
  }
}

function showContent(item) {
  if(item.type === 'text') {
    contentSelected.value = item
  } else if (item.type === 'pdf') {
    window.open(item.content, '_blank');
  }
}

async function verificarEmail(){
  loadEmail.value = true;
  erroEmail.value = false;

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const email = emailInput.value.trim().toLowerCase();
  
  let validacaoPEmail = emailPattern.test(email);

  if (process.env.NODE_ENV === "staging") {
    if(!checkUnico.value){
      validacaoPEmail = (emailPattern.test(email)) && emailInput.value.trim().toLowerCase() == window.ovmConfig.env["EMAIL_PESSOAL"].trim().toLowerCase();
    } else {
      validacaoPEmail = emailPattern.test(email);
    }
  } else {
    if(!checkUnico.value){
      validacaoPEmail = emailPattern.test(email) && emailInput.value.trim().toLowerCase() == window.ovmConfig.env["EMAIL_PESSOAL"].trim().toLowerCase();
    } else {
      validacaoPEmail = emailPattern.test(email);
    }
  }

  if(validacaoPEmail){
    const response = await felixBagAuxStore.sendEmailAuth(emailInput.value.trim().toLowerCase())
    if(response){
      authEmail.value = false;
      authCodigo.value = true;
    } else {
      erroEmail.value = true;
    }
  } else {
    erroEmail.value = true;
  }
  loadEmail.value = false;
}

async function verificarCodigo(){
  loadCodigo.value=true
  erroCodigo.value=false

  if(codigoInput.value != ''){
    const response = await felixBagAuxStore.sendCodAuth(codigoInput.value)
    if(response){
      authEmail.value = false;
      authCodigo.value = false;
      isAuth.value = true;
    } else {
      erroCodigo.value=true
    }
    
  } else {
    erroCodigo.value=true
  }
  loadCodigo.value=false
}
</script>

<template>
  <div id="auth" v-if="!isAuth && checkUnico">
    <h1 style="position: absolute; top: 15%; width: 100%; font-size: 1.2em; color: #BC4AFF;">{{ authEmail ? 'Verificar a sua identidade' : 'Inserir código de verificação'}}</h1>
    <div class="container-auth" v-if="authEmail">
      <p style="font-size: 14px;">Você recebeu um link seguro para: <b>VIVO Mais Família</b></p>
      <p style="color: black; margin-top: 5%; font-size: 0.7em;">A partir de agora, você vai passar por um processo de <b>dupla autenticação</b>, precisará preencher o token duas vezes. Fique atento(a)! </p>
      <p style="color: black; margin-top: 5%; font-size: 0.7em;">Para abrir este link seguro, <b>insira o seu email pessoal.</b></p>
      <input
          type="text"
          id="email"
          placeholder="Inserir email"
          v-model="emailInput"
        />
      <span style="color: #EB3030;margin-top: 3%;" v-if="erroEmail">Endereço de email incorreto</span>
      <v-btn style="margin-top: 8%;" class="btn-criar text-none" @click="verificarEmail()" :loading="loadEmail">
        Avançar
      </v-btn>
    </div>
    <div class="container-auth" v-if="authCodigo">
      <p >Enviamos um código para:</p>
      <div class="label-evento">{{ emailInput }}</div>
      <p style="color: black; font-size: 0.7em;">Para continuar, <b>insira o código</b> que acabamos de enviar, para o email aguarde até um minuto para receber
      </p>
      <input
          type="text"
          id="email"
          placeholder="Inserir código"
          v-model="codigoInput"
        />
        <span style="color: #EB3030;margin-top: 3%;" v-if="erroCodigo">Código incorreto</span>
      <p style="font-size: 0.7em; color: black;">Não recebeu o código? <a @click="verificarEmail()" class="send-cod">Enviar novamente</a></p>
      <v-btn class="btn-criar text-none" @click="verificarCodigo()" :loading="loadCodigo">
        Verificar
      </v-btn>
    </div>
  </div>
  <div id="auth-logged" v-else-if="!isAuth && !checkUnico">
    <h1 style="position: absolute; top: 15%; width: 100%; font-size: 1.2em; color: white;">{{ authEmail ? 'Verificar a sua identidade' : 'Inserir código de verificação'}}</h1>
    <div class="container-auth" v-if="authEmail">
      <p style="font-size: 0.9em;">Agora vamos precisar do seu e-mail, <b>só mais uma vez.</b></p>
      <p style="color: black; margin-top: 12%;">Para continuar e acessar o seu perfil, <b>insira novamente seu email pessoal</b> que foi utilizado no cadastro do perfil</p>
      <input
          type="text"
          id="email"
          placeholder="Inserir email"
          v-model="emailInput"
        />
      <span style="color: #EB3030;margin-top: 3%;" v-if="erroEmail">Endereço de email incorreto</span>
      <v-btn style="margin-top: 20%;" class="btn-criar text-none" @click="verificarEmail()" :loading="loadEmail">
        Avançar
      </v-btn>
    </div>
    <div class="container-auth" v-if="authCodigo">
      <p >Enviamos um <b>novo código</b> para:</p>
      <div class="label-evento">{{ emailInput }}</div>
      <p style="color: black; font-size: 0.7em;">Para continuar, <b>insira o novo código</b> que acabamos de enviar, para o email aguarde até um minuto para receber
      </p>
      <input
          type="text"
          id="email"
          placeholder="Inserir código"
          v-model="codigoInput"
        />
        <span style="color: #EB3030;margin-top: 3%;" v-if="erroCodigo">Código incorreto</span>
      <p style="font-size: 0.7em; color: black;">Não recebeu o código? <a @click="verificarEmail()" class="send-cod">Enviar novamente</a></p>
      <v-btn class="btn-criar text-none" @click="verificarCodigo()" :loading="loadCodigo">
        Verificar
      </v-btn>
    </div>
  </div>
  <div style="width: 100%; height: 100%;" v-else>
    <div v-if="!login" id="thumb">
      <h1>{{ name }},</h1>
      <p>Aproveite essa nova jornada da melhor forma e tenha a melhor experiência junto com a gente</p>
      <v-btn v-if="!requestingLogin" class="btn-acess animate__animated animate__pulse" v-on:click="submitAcess()"> Acesse aqui </v-btn>
      <v-progress-circular
        v-else
        indeterminate
        color="#BC4AFF"
        :size="60"
        :width="7"
        style="position: absolute; top: 72%; left: 39%;">
      </v-progress-circular>
      <p style="margin-top:17px; margin-left: 30%; position: absolute; top: 82.6%;">Este vídeo tem som</p>
    </div>
    <div v-else-if="login && !saibaMais" id="thumb-login">
      <v-btn flat style="height: 6%;
        width: 40%;
        background: rgb(255, 153, 0);
        position: absolute;
        top: 5%;
        right: 7%;" v-if="!loading" @click="saibaMais = true" class="btn-saiba-mais text-none">Saiba mais<img style="margin-left: 5%;" src="https://overmediacast-videos-sp.s3-sa-east-1.amazonaws.com/65ef2558e34902000230c37c/a0ce1adc-3df3-4a48-a037-37d30873f24c.svg" alt=""></v-btn>
      <div v-if="!loginMode" style="position: absolute; top: 53%; height: 31%; width: 100%;">
        <div v-if="!requestingLogin" style="height: 100%;">
          <p>Já possui cadastro?</p>
          <v-btn @click="loginMode = !loginMode" flat style="background: #bc4aff" class="btn-login text-none"> Sim </v-btn>
          <v-btn @click="submitAcess()" flat style="background: #fff; color: #bc4aff;" class="btn-cadastro text-none"> Não </v-btn>
        </div>
        <v-progress-circular
          v-else
          indeterminate
          color="#BC4AFF"
          :size="70"
          :width="7"
          style="margin-top: 15%;"
        ></v-progress-circular>
      </div>
      <button @click="loginMode = !loginMode" v-if="loginMode" class="button-back">
          <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/c1c6afa8-eb43-448e-9caf-9d18f155d4e6.png" alt="">
        </button>
      <div v-if="loginMode" style="position: absolute; top: 53%; height: 31%; width: 100%;">
        <div v-if="!requestingLogin" style="height: 100%;">
          <p style="font-size: 14px;">Insira o seu número de cpf para acessar seu perfil:</p>
          <span class="warning-login" v-if="errorLogin">CPF digitado não está cadastrado</span>
          <v-text-field @input="clearCpf()" maxLength="11" @keypress="numbersOnly" required :rules="[required]" style="width: 85%; margin-left: 7.5%; background: #fff; border-radius: 5px; margin-top: 5%;" v-model="credential" flat density="compact" variant="outlined"></v-text-field>
          <v-btn flat @click="loginToVideo()" style="background: #fff; color: #bc4aff;" class="btn-cadastro text-none"> Entrar </v-btn>
        </div>
        <v-progress-circular
          v-else
          indeterminate
          color="#BC4AFF"
          :size="70"
          :width="7"
          style="margin-top: 15%;"
        ></v-progress-circular>
      </div>
      
      <p style="margin-top:17px; margin-left: 30%; color: white; position: absolute; top: 82.6%; font-size: 14px; width: 70%;">Este vídeo tem som</p>
    </div>
    <div id="saiba-mais" style="width: 100%; height: 100%; background-color: white;" v-else-if="login && saibaMais">
      <div class="header-saiba-mais">
        <button @click="!contentSelected ? saibaMais = !saibaMais : contentSelected = false" style="position: absolute; width: 10%; top: 3%; left: 5%;">
          <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/f150a967-b846-491c-84e6-eb612ca40e3e.svg" alt="">
        </button>
        <img v-if="!contentSelected" style="top: 15%; position: relative;" src="https://overmediacast-videos-sp.s3-sa-east-1.amazonaws.com/65ef2558e34902000230c37c/1487ed41-3f3a-471d-961d-42023597bb04.svg" alt="">
        <p style="font-family: Roboto-light; color: white; position: absolute; top: 14%; font-size: 19px; left: 8%; text-align: left; line-height: 20px; width: 86%;">{{!contentSelected ? 'Conheça o programa' : contentSelected.title}}</p>
      </div>
      <div class="content-area" v-if="!contentSelected">
        <button
          v-for="(item, key) in videobotContentStore.videobotContent.saiba_mais"
          :key="key"
          class="button-saiba-mais"
          @click="showContent(item)"
        >
          <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/90db2715-ae84-475d-acba-5173d98c3c00.svg" alt="">
          <p class="info-title">{{ item.title }}</p>
        </button>
      </div>
      <div class="content-text" v-html="contentSelected.content" v-else>
      </div>
    </div>
  </div>
</template>

<style>
#thumb {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/140eed92-c493-40b2-a52f-ce9318a432b1.png');
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 2;
}

#thumb h1 {
  margin: 92% 7.5% 5px;
  font-size: 1.5rem;
  font-weight: normal;
  text-align: start;
  color: #660099;
}

#thumb p {
  text-align: start;
  margin-left: 7.5%;
  font-size: 14px;
  color: #464646;
  width: 70%;
}

#thumb button,
#thumb .btn-acess {
  margin: 11% auto 0;
  width: 85%;
  height: 6%;
  border-radius: 3px;
  border-radius: 4px;
  background: #660099;
  font-size: 14px;
  color: #fff;
  border: none;
  cursor: pointer;
}

#thumb-login {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5efdd3e5-05c9-4b41-8af5-df112a450972.png');
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 2;
}

#thumb-login .button-back{
  background: none;
  width: 8%;
  height: 6%;
  position: absolute;
  top: 0%;
  left: 5%;
}

#thumb-login h1 {
  margin: 92% 7.5% 5px;
  font-size: 1.5rem;
  font-weight: normal;
  text-align: start;
  color: #660099;
}

#thumb-login p {
  text-align: start;
  margin-left: 7.5%;
  font-size: 20px;
  color: white;
  width: 75%;
}

#thumb-login button {
  margin: 5% auto 0;
  width: 85%;
  height: 21%;
  border-radius: 3px;
  border-radius: 4px;
  background: #660099;
  font-size: 14px;
  color: #fff;
  border: none;
  cursor: pointer;
}

#thumb-login .warning-login {
  width: 100%;
  display: block;
  margin-left: 7.5%;
  text-align: left;
  color: red;
  font-size: 12px;
}

#thumb-login .v-input__details {
    display: none !important;
}

#saiba-mais .header-saiba-mais {
  width: 100%;
  height: 22%;
  background-color: #BC4AFF;
}

#saiba-mais .content-area {
  width: 95%;
  height: 76%;
  overflow: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: 5%;
  align-content: baseline;
  padding-right: 5%;
  padding-top: 5%;
}

#saiba-mais .button-saiba-mais {
  position: relative;
  cursor: pointer;
  margin-bottom: 5%;
  width: 48%;
  min-height: 30%;
  background-color: white;
  border-radius: 15px;
  border: #E8E8E8 1px solid;
  padding-top: 3%;
  padding-bottom: 3%;
}

#saiba-mais .info-title {
  font-size: 11px;
  text-align: center;
  width: 70%;
  margin-left: 15%;
}

#saiba-mais .content-text {
  text-align: start;
  padding-top: 5%;
  padding-left: 7%;
  width: 100%;
  height: 75%;
  overflow-y: auto;
  padding-right: 5%;
  font-family: 'Roboto' !important;
}

#auth {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/cb9e521f-7e14-4b6e-b640-aa0de7af310f.svg');
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 2;
}

#auth-logged {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/242095a2-6300-4edb-a3ba-7fcb441b3ce8.svg');
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 2;
}

#auth-logged .container-auth,
#auth .container-auth{
  background: #fff;
  width: 75%;
  margin: auto;
  margin-top: 55%;
  border-radius: 6px;
}

#auth-logged .container-auth > p,
#auth .container-auth > p{
  text-align: left;
  width: 85%;
  margin: 4% auto 5%;
  font-size: 0.8em;
  color: #660099;
  line-height: normal;
}

#auth-logged .container-auth .label-evento,
#auth .container-auth .label-evento{
  width: 85%;
  margin: auto;
  background: #F8F2FF;
  padding: 4% 6%;
  color: black;
  font-size: 0.7em;
  border-radius: 6px;
  overflow-wrap: break-word;
}

#auth-logged .container-auth input,
#auth .container-auth input{
  width: 85%;
  margin: auto;
  border: 1px solid #E8E8E8;
  border-radius: 6px;
  padding: 3% 6%;
  font-size: 0.7em;
  margin-top: 3%;
}

#auth-logged .container-auth .btn-criar,
#auth .container-auth .btn-criar{
  background: #BC4AFF;
  color: #fff;
  width: 85%;
  margin: 9% auto 4%;
}

#auth-logged .container-auth > span,
#auth .container-auth > span{
  display: block;
  text-align: left;
  width: 85%;
  margin: auto;
  font-size: 0.7em;
  line-height: 1;
}

#auth-logged .container-auth a.send-cod,
#auth .container-auth a.send-cod{
  font-size: 0.8em;
  color: #0000FF;
  text-decoration: underline;
  margin-bottom: 4%;
}
</style>
